import { render, staticRenderFns } from "./officialNo.vue?vue&type=template&id=0c39862d&scoped=true&"
import script from "./officialNo.vue?vue&type=script&lang=js&"
export * from "./officialNo.vue?vue&type=script&lang=js&"
import style0 from "./officialNo.vue?vue&type=style&index=0&id=0c39862d&prod&scoped=true&lang=css&"
import style1 from "./officialNo.vue?vue&type=style&index=1&id=0c39862d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c39862d",
  null
  
)

export default component.exports